'use client'

import { cn } from '@/ui/utils/style'
import { Sparkles } from 'lucide-react'

interface ParallelIncentiveBadgeProps {
  className?: string
}

export function ParallelIncentiveBadge({ className }: ParallelIncentiveBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-[#FBE572]/20 bg-[#FBE572]/10 px-2 py-0.5 font-semibold text-[#FBE572] text-[10px] leading-none shadow-[0_0_18px_rgba(251,229,114,0.14)]',
        className,
      )}
    >
      <Sparkles className="h-2.5 w-2.5" />
      Parallel
    </span>
  )
}
